import React from 'react'
import Theragistcomp from '../../components/caseComponent/theragistComp/theragistComp'

const Theragist = () => {
  return (
    <div>
      <Theragistcomp />
    </div>
  )
}

export default Theragist
